// import { generateRecaptcha } from "helper/firebase";
import { Modal } from "antd";
import { useEffect, useState } from "react";
import InputOTP from "./step/InputOTP";
import SendOTP from "./step/SendOTP";

interface SendOTPModalProps {
  isOpen: boolean;
  onChange: Function;
  onConfirm: Function;
  title?: string;
  content?: string;
}

const SendOTPModal = (props: SendOTPModalProps) => {
  const { isOpen, onChange, onConfirm, title, content } = props;

  const [step, setStep] = useState(1);

  const handleAfterSendOTP = () => {
    onConfirm();
    onChange(false);
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <SendOTP
            title={title}
            subTitle={content}
            currentStep={step}
            onChangeStep={setStep}
            onCancelSendOTP={() => onChange(false)}
            onAfterVerifyStaff={handleAfterSendOTP}
          />
        );
      case 2:
        return <InputOTP onCancelSendOTP={() => onChange(false)} onAfterSendOTP={handleAfterSendOTP} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    // generateRecaptcha("recaptcha-container");
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setStep(1);
    }
  }, [isOpen]);

  return (
    <>
      <div id="recaptcha-container"></div>
      <Modal
        centered
        open={isOpen}
        onCancel={() => {
          onChange(false);
        }}
        footer={null}
        className="rounded-xl bg-white max-w-[90vw] md:max-w-[80vw] lg:max-w-[50vw]"
        width={700}
      >
        <div className="flex flex-col items-center justify-center lg:px-6 lg:py-4 relative">{renderStep()}</div>
      </Modal>
    </>
  );
};

export default SendOTPModal;
